import { useFetchCurrentCompany } from "@/hooks/api/companies"

export function useDataEnrichmentEnabled() {
  const { data: company } = useFetchCurrentCompany()
  return company?.data_enrichment_enabled === true
}
